<template>
  <div class="panel">
    <div v-if="title" class="title">
      {{ title }}
      <div v-if="!hideButton" class="more" @click="toMore">
        {{ buttonText }}>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BasePanel',
  props: {
    title: String,
    buttonText: {
      type: String,
      default: '更多'
    },
    hideButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toMore() {
      this.$emit('toMore')
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  width: 332px;
  border: 1px solid #ebebeb;
  border-top: 4px solid #046bcc;
}

.title {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  color: #262626;
  margin: 0 20px;
  border-bottom: 1px solid #ebebeb;

  .more {
    position: absolute;
    right: 0;
    top: 0px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #858585;
    cursor: pointer;
  }
}
</style>
